import { ReportReplyForm } from './ReportReplyForm'
import { withReportReplyForm } from './withReportReplyForm'

const ConnectedReportReplyForm = withReportReplyForm(ReportReplyForm)

export { ConnectedReportReplyForm as ReportReplyForm }
